import React from "react";
import { RiDeleteBin6Fill } from "react-icons/ri";
import DateInput from "../../commonComponent/CutomDatePicker";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { BsCalendarDate } from "react-icons/bs";
import { BiSolidEditAlt, BiSolidTimeFive } from "react-icons/bi";
import {
  isEmpty,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { useEffect } from "react";
import moment from "moment";
import { AddTasks, deleteReminder } from "../../services/ReminderService";
import { toastMsg } from "../../Utils/AllConstant";
import { addDays } from "date-fns";

function TaskAdd({ setTasks, tasks, handleClose, getReminders, data }) {
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("");
  const [frequency, setFrequency] = useState("Daily");
  const [taskId, setTaskId] = useState();
  // const [newTime, setNewTime] = useState("High");
  const [remDate, setRemDate] = useState(new Date());
  const [error, setError] = useState(false);
  const [repeats, setRepeats] = useState(0);
  const [apiParams, setApiParams] = useState("new");

  // console.log(tasks);

  // useEffect(() => {
  //   getReminders();
  // }, []);

  useEffect(() => {
    if (data) {
      handleChange(data);
    }
  }, [data]);

  const handleChange = (task) => {
    setTaskId(task._id);
    setDescription(task.title);
    setPriority(task.priority);
    setFrequency(task?.frequency);
    setRemDate(new Date(task?.dateTime));
    setRepeats(task?.repeats);
    setApiParams("edit");
  };

  const checkValidation = () => {
    // console.log(description);
    try {
      let errorsResult = error;
      let isValid = true;
      if (!description || isEmpty(description)) {
        isValid = false;
        errorsResult = { ...errorsResult, description: true };
      }
      if (!priority || isEmpty(priority)) {
        isValid = false;
        errorsResult = { ...errorsResult, priority: true };
      }
      if (!frequency || isEmpty(frequency)) {
        isValid = false;
        errorsResult = { ...errorsResult, frequency: true };
      }
      if (!remDate || isEmpty(remDate)) {
        isValid = false;
        errorsResult = { ...errorsResult, remDate: true };
      }
    //   if (!repeats || isEmpty(repeats)) {
    //     isValid = false;
    //     errorsResult = { ...errorsResult, repeats: true };
    //   }

      setError(errorsResult);
      return isValid
    } catch (error) {}
  };

  const deleteTask = async (id) => {
    // console.log(id)
    try {
      const response = await deleteReminder(id);
      if (response.status === 200) {
        showToastSuccess("Reminder Removed");
        getReminders();
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || toastMsg.errorMssg
      );
    }
  };

  const handleReminder = async (e, task) => {
    e.preventDefault();
    if (checkValidation()) {
      var parms = {};
      if (apiParams === "edit") {
        parms["typeId"] = taskId;
      }
      parms["title"] = description;
      parms["type"] = "task";
      parms["dateTime"] = remDate;
      parms["repeats"] = frequency === 'Weekly' ? repeats : frequency === 'Daily' ? ['Sunday','Monday','Tuesday', 'Wednesday','Thursday','Friday','Saturday'] : `${addDays(new Date(remDate), 1).getDate()}`;
      parms["priority"] = priority;
      parms["frequency"] = frequency;
      parms['endDate'] = "2023-12-31T11:23:49.000Z"
      parms["isCompleted"] = [];
      try {
        const response = await AddTasks(parms);
        if (response.status === 200) {
          showToastSuccess(apiParams === "new" ? "Tasks Created" : "Tasks Updated");
          setError(false)
          // getReminders();
          setApiParams("new");
          setDescription("");
          setPriority("");
          setFrequency("");
          setRemDate(new Date());
          setRepeats(0);
        } else {
          showToastError(
            response?.data || response.message || toastMsg.errorMssg
          );
        }
      } catch (error) {
        console.log(error)
        showToastError(
          error?.data?.data || error?.data?.message || toastMsg.errorMssg
        );
      }
    } 
  };


  const renderForm = () => {
    return (
      <div className="row px-3 gap-3" style={{ width: "1200px",  maxWidth:'1300px'}}>
        <div className="col-md-3">
          <label
            htmlFor="title"
            style={{ color: "rgba(155, 155, 155, 1)" }}
            className="pb-2"
          >
            Task Description
          </label>
          <input
            name="title"
            type="text"
            className="description_inputf  "
            placeholder="Task Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          {error.description ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select description"}
            </h6>
          ) : null}
        </div>
        <div className="col-md-2">
          <label
            htmlFor="frequency"
            style={{ color: "rgba(155, 155, 155, 1)" }}
            className="pb-2"
          >
            Frequency
          </label>
          <select
            name="frequency"
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            className="description_inputf"
          >
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
          </select>
          {error.frequency ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select frequency"}
            </h6>
          ) : null}
        </div>
        <div className="col-md-2">
          <label
            htmlFor="priority"
            style={{ color: "rgba(155, 155, 155, 1)" }}
            className="pb-2"
          >
            Priority
          </label>
          <select
            name="priority"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            className="description_inputf"
          >
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
          {error.priority ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select priority"}
            </h6>
          ) : null}
        </div>

        <div className="col-md-2">
          <label
            htmlFor="date"
            style={{ color: "rgba(155, 155, 155, 1)" }}
            className="pb-2"
          >
            Starts On
          </label>
          <DateInput
            value={remDate}
            placeHolder={"Please choose..."}
            onChangeDate={(date) => {
              setRemDate(date);
              // getTimeSlots(format(date, "yyyy-MM-dd"));
              //   setError({ ...error, sessionDate: false });
              // console.log(date);
            }}
            imageStyle={{
              width: "22px",
              height: "22px",
              position: "absolute",
              borderRadius: "0px",
              marginBlock: "17px",
              left: "20px",
            }}
            // maxDate={endDateCreate}
            // minDate={new Date()}
            // minDate={startDateCreate}
            inputClassName={"description_inputf d-flex align-items-center w-75"}
          />
          {error.remDate ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select start date"}
            </h6>
          ) : null}
        </div>
        <div className="col-md-2">
          <label
            htmlFor="priority"
            style={{ color: "rgba(155, 155, 155, 1)" }}
            className="pb-2"
          >
            Repeats
          </label>
          <select
            name="repeats"
            value={repeats}
            onChange={(e) => setRepeats(e.target.value)}
            className="description_inputf"
            disabled = {frequency !== 'Weekly'}
          >
            <option value="Sunday">Sunday</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
          </select>
          {error.repeats ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select repeats on"}
            </h6>
          ) : null}
        </div>

        {tasks?.length > 0 ? (
          <div
            className="col-md-12 mt-1 overflow-y-scroll overflow-x-hidden d-block "
            style={{ height: "200px", width: "100%" }}
          >
            <table  cellPadding={"8px"} style={{width:'100%'}}>
              <thead>
                <th className="col-md-2">Task Title</th>
                <th className="col-md-2">Frequency</th>
                <th className="col-md-2">Priority</th>
                <th className="col-md-2">Starts On</th>
                <th className="col-md-2">Ends On</th>
                <th className="col-md-2">Actions</th>
              </thead>
              {tasks?.map((task, index) => {
                return (
                  <tr
                    className="align-items-center"
                    style={{ backgroundColor: "rgba(227, 236, 237, 1)" }}
                  >
                    <td>{task?.title}</td>
                    <td>{task?.frequency}</td>
                    <td>{task?.priority}</td>

                    <td>
                      <span className="px-1">
                        <BsCalendarDate
                          color="rgba(21, 101, 99, 1)"
                          size={"20px"}
                        />
                      </span>{" "}
                      <span>{moment(new Date(task?.dateTime)).format('DD-MM-YYYY HH:MM A')}</span>
                    </td>
                    <td>
                      <span className="px-1">
                        <BiSolidTimeFive
                          color="rgba(21, 101, 99, 1)"
                          size={"20px"}
                        />
                      </span>{" "}
                      <span>{moment(new Date(task?.endDate)).format('DD-MM-YYYY HH:MM A')}</span>
                    </td>
                    <td className="">
                      <button
                        className="btn me-2"
                        style={{ backgroundColor: "rgba(31, 126, 120, 0.2)" }}
                        onClick={() => handleChange(task)}
                      >
                        <BiSolidEditAlt size={"20px"} />{" "}
                      </button>
                      <button
                        className="btn"
                        style={{ backgroundColor: "rgba(31, 126, 120, 0.2)" }}
                        onClick={() => deleteTask(task?._id)}
                      >
                        <RiDeleteBin6Fill size={"20px"} />{" "}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        ) : null}
        <div className="col-md-12 d-flex align-items-center gap-2 pointer">
          <span
            className=" text-white bold px-1 py-1 d-flex justify-content-center align-items-center "
            style={{
              borderRadius: "50%",
              backgroundColor: "rgba(31, 126, 120, 1)",
            }}
          >
            <FiPlus fontSize={"0.8rem"} fontWeight={"bold"} />
          </span>
          <span
            onClick={(e) => {
              handleReminder(e);
            }}
            style={{ color: "rgba(31, 126, 120, 1)" }}
          >
            {apiParams === "edit" ? "Edit" : "Add"}
          </span>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn text-white"
            style={{ backgroundColor: "rgba(31, 126, 120, 1)" }}
            onClick={(e) => {
              handleReminder(e);
              handleClose();
            }}
          >
            {apiParams === "edit" ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    );
  };
  return <div>{renderForm()}</div>;
}

export default TaskAdd;
